import { MeasureDrillDownInfo } from "../../../../../api/biApi.types";
import { toAmountCalculateByCaption } from "../../customMeasure/utilities/measureConverter";

export function getCalculatedFieldTitle(drillDownInfo: MeasureDrillDownInfo | undefined): string {
  if (drillDownInfo === undefined) return "";
  return toAmountCalculateByCaption(drillDownInfo.field, drillDownInfo.amountType);
}
